import type { ComponentProps } from 'react';

const Share = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_106_52132)">
      <g clipPath="url(#clip1_106_52132)">
        <path
          d="M12.5312 4.21836C12.2375 3.92461 11.7625 3.92461 11.4719 4.21836L7.46875 8.21836C7.175 8.51211 7.175 8.98711 7.46875 9.27773C7.7625 9.56836 8.2375 9.57148 8.52813 9.27773L11.2469 6.55898L11.25 14.2496C11.25 14.6652 11.5844 14.9996 12 14.9996C12.4156 14.9996 12.75 14.6652 12.75 14.2496V6.55898L15.4688 9.27773C15.7625 9.57148 16.2375 9.57148 16.5281 9.27773C16.8187 8.98398 16.8219 8.50898 16.5281 8.21836L12.5312 4.21836ZM6.5 14.7496C6.5 14.334 6.16562 13.9996 5.75 13.9996C5.33437 13.9996 5 14.334 5 14.7496V17.2496C5 18.7684 6.23125 19.9996 7.75 19.9996H16.25C17.7688 19.9996 19 18.7684 19 17.2496V14.7496C19 14.334 18.6656 13.9996 18.25 13.9996C17.8344 13.9996 17.5 14.334 17.5 14.7496V17.2496C17.5 17.9402 16.9406 18.4996 16.25 18.4996H7.75C7.05938 18.4996 6.5 17.9402 6.5 17.2496V14.7496Z"
          fill="#EE4F5E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_106_52132">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_106_52132">
        <rect width="14" height="16" fill="white" transform="translate(5 4)" />
      </clipPath>
    </defs>
  </svg>
);

export default Share;
